module.exports = __webpack_public_path__ + "static/xceltoken (6)-c6081c87db6008f0dd4d9c6e8b1aac11.png";